export var ChangeRequestFileOperation;
(function (ChangeRequestFileOperation) {
    ChangeRequestFileOperation["ADDED"] = "added";
    ChangeRequestFileOperation["REMOVED"] = "removed";
})(ChangeRequestFileOperation || (ChangeRequestFileOperation = {}));
//# sourceMappingURL=change-request-file-operation.js.map